<div class="container p-0 m-0">
  <div class="row">
    <div class="col-12">
      <p class="h1 result-overview-title">
        {{ rendering() | scFieldValue: 'Title' }}
      </p>
      <p class="result-overview-subtitle">
        {{ rendering() | scFieldValue: 'SubTitle' }}
      </p>
    </div>
  </div>

  <div class="grid">
    <div class="grid-address">
      <p wlCSMask>
        {{ address() }}
      </p>
    </div>

    @let buildingData = building();
    @if (buildingData) {
      <div class="grid-map">
        <div class="grid-map-border">
          <wl-solar-panels-result-overview-map
            [rendering]="rendering()"
            [mapUrl]="buildingData.map"
          />
        </div>
      </div>
    }
    @if (rendering().fields.ContactField?.value) {
      <div class="grid-contact">
        <wl-rich-text-wrapper [field]="rendering().fields.ContactField">
          <div class="mt-0"></div>
        </wl-rich-text-wrapper>
      </div>
    }

    @let productData = product();
    @if (productData) {
      <div class="grid-summary">
        <p class="h4 h3-md m-0">
          {{ rendering() | scFieldValue: 'DescriptionTitle' }}
        </p>

        @let descriptionText = rendering() | scFieldValue: 'DescriptionText';
        @if (descriptionText) {
          <p>
            {{
              descriptionText
                | interpolate
                  : {
                      variables: {
                        maxPanels: productData.maxPanelAmount,
                        recommendedPanels: productData.recommendation.amount,
                      },
                    }
            }}
          </p>
        }
        <sc-placeholder
          name="solar-panels-result-overview-summary"
          [rendering]="rendering()"
        >
          <crnt-icon
            *scPlaceholderLoading
            class="text-brand"
            size="3x"
            icon="spinner-third"
            animation="spin"
          />
        </sc-placeholder>

        @let faqRenderingData = faqRendering();
        @if (faqRenderingData) {
          <wl-faq-container [rendering]="faqRenderingData" />
        }
      </div>
    }

    <div class="grid-proposition">
      @if (rendering().fields.PropositionBoxEnabled.value === true) {
        <wl-solar-panels-proposition-box
          class="mb-2"
          [rendering]="rendering()"
          (openInfoModal)="onOpenPropositionMoreInfoModal($event)"
        />
      }
    </div>

    <div class="grid-submit">
      @if (rendering().fields.InvertButtonPriority.value) {
        @if (secondaryButtonLinkValue && secondaryButtonLinkValue.href) {
          <crnt-button
            class="mt-4"
            variant="tertiary"
            [fullWidth]="true"
            *wlGenericLink="secondaryButtonLinkValue"
            wlTrackLink
            [trackLinkInfo]="{
              eventType: 'button-click',
              rendering: rendering(),
              field: secondaryButtonLinkValue,
            }"
          >
            {{ secondaryButtonLinkValue.text }}
          </crnt-button>
        }
        <crnt-button
          (click)="onClickSubmitButton(product())"
          class="mt-2"
          [fullWidth]="true"
          wlAutomationId="resultOverview.submit"
        >
          {{ rendering() | scFieldValue: 'NextStepButtonText' }}
        </crnt-button>
      } @else {
        <crnt-button
          (click)="onClickSubmitButton(product())"
          [fullWidth]="true"
          wlAutomationId="resultOverview.submit"
        >
          {{ rendering() | scFieldValue: 'NextStepButtonText' }}
        </crnt-button>
        @if (secondaryButtonLinkValue && secondaryButtonLinkValue.href) {
          <crnt-button
            class="mt-2"
            variant="tertiary"
            [fullWidth]="true"
            *wlGenericLink="secondaryButtonLinkValue"
            wlTrackLink
            [trackLinkInfo]="{
              eventType: 'button-click',
              rendering: rendering(),
              field: secondaryButtonLinkValue,
            }"
          >
            {{ secondaryButtonLinkValue.text }}
          </crnt-button>
        }
      }
    </div>
    <div class="grid-usps">
      <wl-rich-text-wrapper [field]="rendering().fields.Usps">
        <div class="mt-2"></div>
      </wl-rich-text-wrapper>
    </div>
  </div>
</div>
